import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { NavController } from '@ionic/angular';
import { AuthService } from '../services/auth/auth.service';
import { OnboardingService } from '../services/onboarding/onboarding.service';
import { ProfileService } from '../services/profile/profile.service';

@Injectable({ providedIn: 'root' })
export class NonAuthGuard implements CanActivate {
  private router = inject(Router);
  private authService = inject(AuthService);
  private profile = inject(ProfileService);
  private onboardingService = inject(OnboardingService);
  private navController = inject(NavController);

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    if (await this.authService.isLoggedin()) {
      if (!this.profile.profile) await this.profile.getProfile();
      const nextRoute = this.onboardingService.getNextRoute() || 'tabs';
      this.navController.setDirection('root');
      return this.router.parseUrl(nextRoute);
    }

    return true;
  }
}
